/**
 * Error indicating an XML parser problem
 */
export default class XMLParserError extends Error {}
